import { render, staticRenderFns } from "./MonthlyExamModal.vue?vue&type=template&id=0ede3d80&scoped=true&"
import script from "./MonthlyExamModal.vue?vue&type=script&lang=ts&"
export * from "./MonthlyExamModal.vue?vue&type=script&lang=ts&"
import style0 from "./MonthlyExamModal.vue?vue&type=style&index=0&id=0ede3d80&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ede3d80",
  null
  
)

export default component.exports